// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__xmJ2p","right":"styles_right__134Ff"};